import { generateOneLinkUrl } from '@cian/appsflyer-onelink';
import * as React from 'react';

import { useApplicationContext } from './applicationContext';

export const useDownloadNativeAppUrl = (campaignTitle?: string) => {
  const { config } = useApplicationContext();
  const downLoadUrl = config.get<string>('mobileBanner.browserUrl') ?? '';

  const [downloadNativeAppUrl, setDownloadNativeAppUrl] = React.useState('');

  React.useEffect(() => {
    const url = generateOneLinkUrl(downLoadUrl, 'mobile_site', campaignTitle) || '';
    setDownloadNativeAppUrl(url);
  }, []);

  return downloadNativeAppUrl;
};
